// apps/agent-studio/src/shared/analytics/provider.tsx
import { useEffect, useRef, type ReactNode } from 'react';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { setGroup, track } from './client';

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  const workspaceId = useCurrentWorkspaceId();
  const prevWorkspaceId = useRef<string | null>(null);

  useEffect(() => {
    if (!workspaceId) return;

    if (prevWorkspaceId.current === null) {
      prevWorkspaceId.current = workspaceId;
      return;
    }

    if (prevWorkspaceId.current === workspaceId) return;

    setGroup('workspace', workspaceId);
    track('workspace_switched', {
      from_workspace_id: prevWorkspaceId.current,
      to_workspace_id: workspaceId,
    });
    prevWorkspaceId.current = workspaceId;
  }, [workspaceId]);

  return <>{children}</>;
}
